export const HEADBAND_MESSAGE_OPTIONS = [
  { label: 'information', value: 'INFORMATION', mdbIcons: 'circle-info' },
  { label: 'MAJ', value: 'MAJ', mdbIcons: 'arrows-rotate' },
  { label: 'correction', value: 'CORRECTION', mdbIcons: 'wrench' },
  { label: 'urgent', value: 'URGENT', mdbIcons: 'triangle-exclamation' },
];
